module.exports = __webpack_public_path__ + "static/img/freshman-python-hover.90eaa0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/he/freshman-python-hover.png
// module id = 25Kk
// module chunks = 1